export interface IOrderDetail {
	id: string;
	entityType: string;
	creationDateTime: string | null;
	transactionDate: string | null;
	googleAnalyticsId: string | null;
	googleAnalyticsSessionId: string | null;
	metaFbc: string | null;
	metaFbp: string | null;
	ipAddress: string | null;
	orderRequestS3Path: string | null;
	policyS3Path: string | null;
	providerResultS3Path: string | null;
	requestId: string | null;
	policyId: string | null;
	apiClientName: string | null;
	status: OrderStatus;
	orderType: OrderType;
	financial: IFinancial | null;
	mainApplicant: IPolicyHolder | null;
	paymentDetails: PaymentDetails | null;
	package: IPackage | null;
	houseInformation: IBuilding | null;
	productCategory: ProductCategory;
	familyComposition: AdnGez | null;
	underwritingResult: AdnRes | null;
	urmSource: string | null;
	note: string | null;
	userId: string | null;
	comparatorId: string | null;
	sessionId: string | null;
	comparisonId: string | null;
	webhookProvider: string | null;
	senderId: string | null;
	processReference: string | null;
	userDesiresIncentive: boolean | null;
}

export enum OrderStatus {
	Queued = 0,
	Processing = 1,
	QueuedForSaving = 2,
	Error = 3,
	UnderReview = 4,
	Done = 5
}

export enum OrderType {
	Affiliate,
	FunnelMga,
	NotOrderable
}

export interface IFinancial {
	financialStatus: AdnRes | null;
	totalCommission: number | null;
	partnerCommission: number | null;
	kiziCommission: number | null;
	customProperties: IFinancialProperties | null;
}

export enum AdnRes {
	V1,
	V2,
	V3,
	V4,
	VA,
	VB,
	VD,
	VE,
	VF,
	VI,
	VN,
	VO,
	VS,
	VU,
	VW
}

export interface IFinancialProperties {
	financialStatusChangeDate: string | null;
}

export interface IPolicyHolder {
	prefixes: string | null;
	initials: string | null;
	callName: string | null;
	surname: string | null;
	nationality: IsoLan | null;
	genderOrLegalPersonType: AdnGes | null;
	workPhoneNumber: string | null;
	mobile: string | null;
	bsn: string | null;
	email: string | null;
	birthdate: string | null;
	address: IAddress | null;
	customProperties: IPolicyHolderProperties | null;
}

export interface IAddress {
	id: string;
	addressType: AdnAdr | null;
	city: string | null;
	country: IsoLan | null;
	houseNumber: number | null;
	houseNumberAddition: string | null;
	houseLetter: string | null;
	postalCode: string | null;
	street: string | null;
}

export enum AdnAdr {
	V001,
	V002,
	V003,
	V004,
	V013,
	V014,
	V015,
	V016,
	V017
}

export enum IsoLan {
	VAD,
	VAE,
	VAF,
	VAG,
	VAI,
	VAL,
	VAM,
	VAN,
	VAO,
	VAQ,
	VAR,
	VAS,
	VAT,
	VAU,
	VAW,
	VAX,
	VAZ,
	VBA,
	VBB,
	VBD,
	VBE,
	VBF,
	VBG,
	VBH,
	VBI,
	VBJ,
	VBL,
	VBM,
	VBN,
	VBO,
	VBQ,
	VBR,
	VBS,
	VBT,
	VBV,
	VBW,
	VBY,
	VBZ,
	VCA,
	VCC,
	VCD,
	VCF,
	VCG,
	VCH,
	VCI,
	VCK,
	VCL,
	VCM,
	VCN,
	VCO,
	VCR,
	VCS,
	VCU,
	VCV,
	VCW,
	VCX,
	VCY,
	VCZ,
	VDE,
	VDJ,
	VDK,
	VDM,
	VDO,
	VDZ,
	VEC,
	VEE,
	VEG,
	VEH,
	VER,
	VES,
	VET,
	VFI,
	VFJ,
	VFK,
	VFM,
	VFO,
	VFR,
	VGA,
	VGB,
	VGD,
	VGE,
	VGF,
	VGG,
	VGH,
	VGI,
	VGL,
	VGM,
	VGN,
	VGP,
	VGQ,
	VGR,
	VGS,
	VGT,
	VGU,
	VGW,
	VGY,
	VHK,
	VHM,
	VHN,
	VHR,
	VHT,
	VHU,
	VID,
	VIE,
	VIL,
	VIM,
	VIN,
	VIO,
	VIQ,
	VIR,
	VIS,
	VIT,
	VJE,
	VJM,
	VJO,
	VJP,
	VKE,
	VKG,
	VKH,
	VKI,
	VKM,
	VKN,
	VKP,
	VKR,
	VKW,
	VKY,
	VKZ,
	VLA,
	VLB,
	VLC,
	VLI,
	VLK,
	VLR,
	VLS,
	VLT,
	VLU,
	VLV,
	VLY,
	VMA,
	VMC,
	VMD,
	VME,
	VMF,
	VMG,
	VMH,
	VMK,
	VML,
	VMM,
	VMN,
	VMO,
	VMP,
	VMQ,
	VMR,
	VMS,
	VMT,
	VMU,
	VMV,
	VMW,
	VMX,
	VMY,
	VMZ,
	VNA,
	VNC,
	VNE,
	VNF,
	VNG,
	VNI,
	VNL,
	VNO,
	VNP,
	VNR,
	VNU,
	VNZ,
	VOM,
	VPA,
	VPE,
	VPF,
	VPG,
	VPH,
	VPK,
	VPL,
	VPM,
	VPN,
	VPR,
	VPS,
	VPT,
	VPW,
	VPY,
	VQA,
	VRE,
	VRO,
	VRS,
	VRU,
	VRW,
	VSA,
	VSB,
	VSC,
	VSD,
	VSE,
	VSG,
	VSH,
	VSI,
	VSJ,
	VSK,
	VSL,
	VSM,
	VSN,
	VSO,
	VSR,
	VSS,
	VST,
	VSV,
	VSX,
	VSY,
	VSZ,
	VTC,
	VTD,
	VTF,
	VTG,
	VTH,
	VTJ,
	VTK,
	VTL,
	VTM,
	VTN,
	VTO,
	VTR,
	VTT,
	VTV,
	VTW,
	VTZ,
	VUA,
	VUG,
	VUM,
	VUS,
	VUY,
	VUZ,
	VVA,
	VVC,
	VVE,
	VVG,
	VVI,
	VVN,
	VVU,
	VWF,
	VWS,
	VYE,
	VYT,
	VZA,
	VZM,
	VZW,
	VZZ
}

export interface IPolicyHolderProperties {
	consumentenbondMember: boolean | null;
	consumentenbondUserId: string | null;
}

export interface PaymentDetails {
	collectionAccountIban: string | null;
	paymentTermInMonths: number | null;
	paymentMethod: AdnInc | null;
}

export enum AdnInc {
	VA,
	VB,
	VC,
	VD,
	VE,
	VI,
	VK,
	VM,
	VN,
	VP,
	VR,
	VS,
	VT,
	VV,
	VW,
	VZ
}

export interface IPackage {
	productDescription: string | null;
	offerNumber: string | null;
	effectiveDate: string | null;
	totalInstallmentAmount: number | null;
	deductibleAmount: number | null;
	policyDetails: IPolicyDetail[] | null;
	externalSourceName: string | null;
	companyNameDescription: string | null;
	customProperties: IPackageProperties | null;
	documents: Document[] | null;
}

export interface IPolicyDetail {
	refKey: string | null;
	contractNumber: string | null;
	productName: string | null;
	productDescription: string | null;
	companyNameDescription: string | null;
	totalInstallmentAmount: number | null;
	deductibleAmount: number | null;
	financial: IFinancial | null;
	oneOffCostsAmount: number | null;
	coverageBuildings: ICoverageBuilding[] | null;
	coverageHomes: ICoverageHome[] | null;
	coverageBasicHealths: IBasicHealth[] | null;
	coverageAdditionalHealths: IAdditionalHealth[] | null;
	coverageDentistHealths: IDentistHealth[] | null;
	additionalCoverages: IAdditionalCoverage[] | null;
	customProperties: IPolicyDetailProperties | null;
	partyPolicyHolders: IPolicyHolder[] | null;
}

export interface IFinancial {
	financialStatus: AdnRes | null;
	totalCommission: number | null;
	partnerCommission: number | null;
	kiziCommission: number | null;
	customProperties: IFinancialProperties | null;
}

export interface IFinancialProperties {
	financialStatusChangeDate: string | null;
}

export interface ICoverageBuilding {
	coverageCode: AdnDek | null;
}

export interface Document {
	documentUrl: string | null;
	fileName: string[] | null;
	fileExtension: string | null;
}

export enum AdnDek {
	V1001,
	V1002,
	V1008,
	V1012,
	V1013,
	V1014,
	V1015,
	V1023,
	V1024,
	V1100,
	V1101,
	V1102,
	V1103,
	V1104,
	V1105,
	V1110,
	V1112,
	V1120,
	V1200,
	V1235,
	V1236,
	V1237,
	V1238,
	V1245,
	V1260,
	V1281,
	V1500,
	V1510,
	V1520,
	V1521,
	V1522,
	V1530,
	V1531,
	V1532,
	V1533,
	V1534,
	V1535,
	V1536,
	V1537,
	V1538,
	V1539,
	V1999,
	V2001,
	V2002,
	V2003,
	V2004,
	V2005,
	V2006,
	V2007,
	V2009,
	V2010,
	V2011,
	V2012,
	V2013,
	V2014,
	V2025,
	V2026,
	V2027,
	V2028,
	V2033,
	V2034,
	V2035,
	V2036,
	V2037,
	V2038,
	V2039,
	V2040,
	V2041,
	V2042,
	V2045,
	V2046,
	V2047,
	V2049,
	V2050,
	V2051,
	V2052,
	V2060,
	V2067,
	V2070,
	V2080,
	V2090,
	V2091,
	V2092,
	V2100,
	V2101,
	V2102,
	V2103,
	V2104,
	V2105,
	V2106,
	V2999,
	V3001,
	V3002,
	V3003,
	V3004,
	V3005,
	V3006,
	V3007,
	V3008,
	V3010,
	V3015,
	V3020,
	V3022,
	V3028,
	V3030,
	V3031,
	V3032,
	V3101,
	V3104,
	V3106,
	V3110,
	V3112,
	V3113,
	V3115,
	V3119,
	V3120,
	V3121,
	V3130,
	V3255,
	V3401,
	V3403,
	V3410,
	V3411,
	V3412,
	V3413,
	V3414,
	V3415,
	V3416,
	V3417,
	V3500,
	V3501,
	V3502,
	V3510,
	V3511,
	V3512,
	V3515,
	V3520,
	V3525,
	V3530,
	V3531,
	V3532,
	V3550,
	V3551,
	V3552,
	V3553,
	V3570,
	V3575,
	V3580,
	V3999,
	V4999,
	V5001,
	V5002,
	V5003,
	V5004,
	V5005,
	V5006,
	V5007,
	V5008,
	V5009,
	V5010,
	V5011,
	V5012,
	V5013,
	V5014,
	V5016,
	V5018,
	V5019,
	V5020,
	V5021,
	V5022,
	V5023,
	V5024,
	V5025,
	V5026,
	V5027,
	V5028,
	V5029,
	V5030,
	V5032,
	V5033,
	V5034,
	V5044,
	V5045,
	V5046,
	V5050,
	V5302,
	V5400,
	V5404,
	V5405,
	V5406,
	V5407,
	V5408,
	V5420,
	V5421,
	V5422,
	V5430,
	V5434,
	V5440,
	V5443,
	V5444,
	V5454,
	V5464,
	V5500,
	V5508,
	V5700,
	V5701,
	V5702,
	V5703,
	V5704,
	V5705,
	V5706,
	V5707,
	V5710,
	V5730,
	V5741,
	V5742,
	V5743,
	V5744,
	V5745,
	V5746,
	V5760,
	V5800,
	V5801,
	V5802,
	V5804,
	V5850,
	V5880,
	V5950,
	V5952,
	V5954,
	V5955,
	V5956,
	V5957,
	V5958,
	V5960,
	V5962,
	V5963,
	V5964,
	V5965,
	V5966,
	V5967,
	V5970,
	V5975,
	V5999,
	V6001,
	V6002,
	V6010,
	V6011,
	V6012,
	V6013,
	V6014,
	V6015,
	V6016,
	V6017,
	V6020,
	V6021,
	V6022,
	V6023,
	V6024,
	V6025,
	V6026,
	V6027,
	V6028,
	V6029,
	V6030,
	V6031,
	V6032,
	V6033,
	V6034,
	V6035,
	V6036,
	V6037,
	V6038,
	V6039,
	V6040,
	V6041,
	V6042,
	V6043,
	V6044,
	V6045,
	V6050,
	V6051,
	V6052,
	V6060,
	V6070,
	V6071,
	V6072,
	V6073,
	V6074,
	V6101,
	V6102,
	V6103,
	V6105,
	V6200,
	V6990,
	V6991,
	V6993,
	V6994,
	V6995,
	V6997,
	V6998,
	V6999,
	V7001,
	V7002,
	V7003,
	V7999,
	V8001,
	V8002,
	V8003,
	V8100,
	V8101,
	V8102,
	V8200,
	V8201,
	V8202,
	V8999,
	V9001,
	V9002,
	V9110,
	V9111,
	V9120,
	V9130,
	V9210,
	V9220,
	V9500,
	V9501,
	V9502,
	V9503,
	V9504,
	V9505,
	V9510,
	V9520,
	V9521,
	V9522,
	V9523,
	V9528,
	V9529,
	V9530,
	V9531,
	V9532,
	V9540,
	V9550,
	V9560,
	V9561,
	V9562,
	V9563,
	V9564,
	V9570,
	V9571,
	V9572,
	V9580,
	V9581,
	V9589,
	V9590,
	V9591,
	V9592,
	V9593,
	V9594,
	V9595,
	V9596,
	V9901,
	V9903,
	V9904,
	V9905,
	V9906,
	V9907,
	V9908,
	V9911,
	V9990,
	V9999,
	V10100,
	V10101,
	V10105,
	V10123,
	V10199,
	V10201,
	V10208,
	V10210,
	V10211,
	V10212,
	V10213,
	V10214,
	V10215,
	V10299,
	V10300,
	V10301,
	V10302,
	V10303,
	V10304,
	V10305,
	V10306,
	V10399,
	V10400,
	V10500,
	V10800,
	V10900,
	V10904,
	V10906,
	V10940,
	V10999,
	V19999,
	V20000
}

export interface ICoverageHome {
	coverageCode: AdnDek | null;
}

export interface IBasicHealth {
	deductibleAmount: number | null;
	deductibleDiscountAmount: number | null;
}

export interface IAdditionalHealth {
	deductibleAmount: number | null;
	deductibleDiscountAmount: number | null;
}

export interface IDentistHealth {
	deductibleAmount: number | null;
	deductibleDiscountAmount: number | null;
}

export interface IAdditionalCoverage {
	name: string;
	totalInstallmentAmount: number;
	deductibleAmount: number;
}

export interface IPolicyDetailProperties {
	productKrn: string | null;
	externalId: string | null;
	affiliateId: string | null;
	validationDate: string | null;
}

export interface IPolicyHolder {
	prefixes: string | null;
	initials: string | null;
	callName: string | null;
	surname: string | null;
	genderOrLegalPersonType: AdnGes | null;
	workPhoneNumber: string | null;
	mobile: string | null;
	email: string | null;
	birthdate: string | null;
	address: IAddress | null;
	customProperties: IPolicyHolderProperties | null;
}

export enum AdnGes {
	VM,
	VO,
	VR,
	VV
}

export interface IPolicyHolderProperties {
	consumentenbondMember: boolean | null;
	consumentenbondUserId: string | null;
}

export interface IBuilding {
	address: IAddress | null;
	homeType: AdnTyp | null;
	constructionYear: number | null;
	propertyOfInsured: boolean | null;
}

export enum AdnTyp {
	V0,
	V1,
	V2,
	V3,
	V4,
	V5,
	V6,
	V7,
	V8,
	V9,
	V10,
	VA,
	VB,
	VC,
	VD,
	VE,
	VF,
	VG,
	VH,
	VI,
	VJ,
	VK,
	VL,
	VM,
	VN,
	VO,
	VP,
	VQ,
	VR,
	VS,
	VT,
	VU,
	VV,
	VW,
	VX,
	VY,
	VZ
}

export enum ProductCategory {
	NonSpecific,
	Car,
	Energy,
	Home,
	Liability,
	TriplePlay,
	Travel,
	HealthCare,
	Funeral,
	Loan,
	SimOnly,
	Animal,
	Bike,
	SolarPanels,
	Savings,
	EventBased
}

export interface IPackageProperties {
	providerKrn: string | null;
	supplierKrn: string | null;
	productKrn: string | null;
	externalId: string | null;
	affiliateUrl: string | null;
}

export enum AdnGez {
	VA,
	VH,
	VI,
	VK,
	VT,
	VZ
}
